interface IENV {
	appCode?: string;
	productCode?: string;
	envType?: string;
	apiEndpoint?: string;
	appName?: string;
	/** Per-product "Goto Console" targets, keyed by product type (pos/hrm/asm/file). */
	consoles?: Record<string, string>;
	/** Product name shown in the UI and appended to the browser tab title. */
	brandName?: string;
	/** Public path to this deployment's logo, e.g. "/logo.png". */
	brandLogo?: string;
	/** Public path to this deployment's favicon. */
	brandFavicon?: string;
	/** The brand's two colours (the logo's): main and dark. They paint the sign-in screens. */
	brandColor?: string;
	brandColorDark?: string;
	/** Support address shown in the footer. */
	supportEmail?: string;
	/** Marketing site origin for the public About/Contact links. Empty => links hidden. */
	marketingUrl?: string;
	/**
	 * Short module codes this deployment is allowed to show (e.g. ["HRM"]).
	 * Empty means "no filtering" — which is what every ErpBoi build does.
	 */
	moduleAllowlist?: string[];
}

export const ENV: IENV = {
	appCode: process.env.REACT_APP_CODE || '',
	productCode: process.env.REACT_APP_PRODUCT_CODE || '',
	appName: process.env.REACT_APP_NAME || "",
	envType: process.env.REACT_APP_ENV_TYPE || "",
	apiEndpoint: process.env.REACT_APP_GETWAY || "",
	consoles: {
		store: process.env.REACT_APP_CONSOLE_STORE || "",
		hrm: process.env.REACT_APP_CONSOLE_HRM || "",
		ams: process.env.REACT_APP_CONSOLE_AMS || "",
		docs: process.env.REACT_APP_CONSOLE_DOCS || "",
		// Keyed by LOWERCASE public.modules.code — that is how Dashboard/Home look a console up.
		// (`itam` has no entry: pre-existing, so its tile falls back to https://<host_origin>.)
		desk: process.env.REACT_APP_CONSOLE_DESK || "",
		labor: process.env.REACT_APP_CONSOLE_LABOR || "",
	},
	brandName: process.env.REACT_APP_BRAND_NAME || "ErpBoi",
	brandLogo: process.env.REACT_APP_BRAND_LOGO || "/logo.png",
	brandFavicon: process.env.REACT_APP_BRAND_FAVICON || "/favicon.ico",
	// ErpBoi's logo blue and navy.
	brandColor: process.env.REACT_APP_BRAND_COLOR || "#015fee",
	brandColorDark: process.env.REACT_APP_BRAND_COLOR_DARK || "#011746",
	supportEmail: process.env.REACT_APP_SUPPORT_EMAIL || "support@erpboi.com",
	marketingUrl: process.env.REACT_APP_MARKETING_URL || "",
	moduleAllowlist: (process.env.REACT_APP_MODULE_ALLOWLIST || "")
		.split(",")
		.map((s) => s.trim().toUpperCase())
		.filter(Boolean),
};
